// schema for order create form
import { REQUIRED_MESSAGE, requiredNumber } from '@wyz/utils';
import { z } from 'zod';
import { CONTAINER_TYPES } from '~/common/schemas';

export const containerOrderSearchFormSchema = z.object({
  hq: requiredNumber,
  supplier: requiredNumber,
  containerType: z.enum(CONTAINER_TYPES, {
    error: (issue) =>
      issue.input === undefined ? REQUIRED_MESSAGE : undefined,
  }),
  quantity: requiredNumber,
});

export const searchTyreFilterSchema = z.object({
  identifier: z.string().optional(),
  brand: z.coerce.number<number>().optional(),
  season: z.coerce.number<number>().optional(),
});
